export default __webpack_public_path__ + "static/media/people.71b2fbce.png";